import Flatpickr from 'flatpickr';
import template from './calendar.html';
import './calendar.scss';

export class CalendarController {
  constructor($element, $timeout) {
    'ngInject';

    [this.$element] = Array.from($element);
    this.$timeout = $timeout;

    this._instance = null;
    this._queryPrefix = '#nzCalendar_field_';
  }
  $postLink() {
    this.$timeout(() => {
      const query = `${this._queryPrefix}${this.id}`;
      this._instance = new Flatpickr(
        this.$element.querySelector(query),
        this.options,
      );
    });
  }
  $destroy() {
    this._instance.destroy();
  }
}

export default {
  controller: CalendarController,
  template,
  bindings: {
    id: '@',
    options: '<',
    placeholder: '@',
    disableCalendar: '<',
  },
};
